// DEEJAIBOX Cart Minimum Order Control
(function() {
  const MIN_ORDER_USD = 59;

  function getCartTotal() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // total_price is in cents for USD, satangs for THB etc.
        // items_subtotal_price gives us the items total
        // Use currency to determine divisor
        const currency = cart.currency;
        // For most currencies, divide by 100 to get major unit
        const divisor = 100;
        return {
          total: cart.total_price / divisor,
          currency: currency,
          itemCount: cart.item_count,
          items: cart.items
        };
      });
  }

  function updateCheckoutButtons(cartData) {
    const total = cartData.total;
    const belowMin = total < MIN_ORDER_USD;

    // Find all checkout buttons
    const checkoutBtns = document.querySelectorAll(
      '#checkout, #CartDrawer-Checkout, [name="checkout"], .cart__checkout-button'
    );

    // Find or create warning element
    let warning = document.getElementById('deejaibox-min-warning');

    checkoutBtns.forEach(btn => {
      if (belowMin) {
        btn.disabled = true;
        btn.style.opacity = '0.45';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
      } else {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
        btn.style.pointerEvents = '';
      }
    });

    // Update warning message
    if (!warning) {
      warning = document.createElement('div');
      warning.id = 'deejaibox-min-warning';
      warning.style.cssText = 'margin:0 0 14px;padding:12px 16px;background:#fff8e7;border:1px solid #C9A84C;border-radius:8px;text-align:center;display:none;';
      // Insert before first checkout button's parent
      const firstBtn = document.querySelector('#checkout, #CartDrawer-Checkout');
      if (firstBtn) {
        const parent = firstBtn.closest('.cart__ctas') || firstBtn.parentNode;
        parent.parentNode.insertBefore(warning, parent);
      }
    }

    if (belowMin) {
      const gap = (MIN_ORDER_USD - total).toFixed(2);
      warning.innerHTML = '<p style="margin:0;font-size:13px;color:#8B6914;line-height:1.6;">' +
        '🛍️ <strong>Minimum order: $' + MIN_ORDER_USD + '</strong><br>' +
        'Add <strong>$' + gap + '</strong> more to checkout</p>';
      warning.style.display = 'block';
    } else {
      warning.style.display = 'none';
    }

    // Also block form submission
    const cartForms = document.querySelectorAll('#cart, #CartDrawer-Form, form[action="/checkout"]');
    cartForms.forEach(form => {
      form.onsubmit = belowMin ? (e) => { e.preventDefault(); return false; } : null;
    });

    // Block PayPal and other express buttons
    const expressButtons = document.querySelectorAll(
      '.additional-checkout-buttons, [data-testid="payment-button"], .shopify-payment-button'
    );
    expressButtons.forEach(el => {
      el.style.display = belowMin ? 'none' : '';
    });
  }

  function init() {
    getCartTotal().then(updateCheckoutButtons).catch(console.error);

    // Re-check when cart changes (quantity updates)
    document.addEventListener('cart:updated', () => {
      getCartTotal().then(updateCheckoutButtons).catch(console.error);
    });

    // Monitor for DOM changes (cart drawer opening, quantity changes)
    const observer = new MutationObserver(() => {
      getCartTotal().then(updateCheckoutButtons).catch(console.error);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });

    // Also check on quantity input changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('[name="quantity"], .quantity__input')) {
        setTimeout(() => {
          getCartTotal().then(updateCheckoutButtons).catch(console.error);
        }, 500);
      }
    });

    // Intercept direct URL navigation to checkout
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="checkout"]');
      if (link) {
        getCartTotal().then(cart => {
          if (cart.total < MIN_ORDER_USD) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
